import { dashboardPreAlertApis, preAlertApis as nextPreAlertApis } from '@apis/next/preAlertApis';
import { preAlertApis } from '@apis/preAlertApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchPreAlert } from '@models/PreAlert';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchPreAlert = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchPreAlert) => {
      const response = await preAlertApis.patch('/dashboard/pre-alert/{d2d_no}/', {
        path: { d2d_no },
        body,
      });
      if (response[400]) {
        throw new FormError('PatchPreAlert', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          nextPreAlertApis.getKeyByPath('get', '/pre-alert/:d2d_no', { params: { d2d_no } }),
        );
        queryClient.invalidateQueries(nextPreAlertApis.getKeyByPath('get', '/pre-alert'));
        queryClient.invalidateQueries(
          dashboardPreAlertApis.getKeyByPath('get', '/dashboard/pre-alert'),
        );
        queryClient.invalidateQueries(
          dashboardPreAlertApis.getKeyByPath('get', '/dashboard/pre-alert/:d2d_no', {
            params: { d2d_no },
          }),
        );
        queryClient.invalidateQueries(['/dashboard/tracking-data/', d2d_no]);
      },
    },
  );
};
